var React = require('react');

function Cards (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"0.5","y":"0.5","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"5.4","height":"5.4","key":0}),React.createElement("rect",{"x":"10","y":"0.5","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"5.4","height":"5.4","key":1}),React.createElement("rect",{"x":"10","y":"10","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"5.4","height":"5.4","key":2}),React.createElement("rect",{"x":"0.5","y":"10","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"5.4","height":"5.4","key":3})]));
}

Cards.displayName = "Cards";

Cards.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Cards;

Cards.default = Cards;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/cards.svg
// module id = ../icon/src/icons/cards.svg
// module chunks = 0